import { NavLink } from "react-router";
import {
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSubItem,
} from "./ui/sidebar";
import { IlluminateUserPermissionsEnum } from "@/api/openapi";
import { FeatureFlag } from "@/constants";
import AccessGuard from "@/components/access-guard";

const LoadManagementLink = ({
    to,
    label,
    nested,
}: {
    to: string;
    label: string;
    nested: boolean;
}) => {
    const Item = nested ? SidebarMenuSubItem : SidebarMenuItem;

    return (
        <Item>
            <SidebarMenuButton asChild>
                <NavLink className={"text-default-color"} to={to}>
                    <span>{label}</span>
                </NavLink>
            </SidebarMenuButton>
        </Item>
    );
};

/** The Load Management links, scoped to a single core's `deviceIdentity`. */
export const LoadManagementLinks = ({
    base,
    isCoreChargerLogs,
    nested = true,
}: {
    base: string;
    isCoreChargerLogs: boolean;
    nested?: boolean;
}) => (
    <>
        <LoadManagementLink
            to={`${base}/core-configuration`}
            label="Configuration"
            nested={nested}
        />
        <AccessGuard
            unauthorizedBehaviour="hide"
            featureFlags={[FeatureFlag.CORE_EXPORT_CHARGER_LOGS_FLAG]}
            permissions={[IlluminateUserPermissionsEnum.DeviceLogsRead]}
            overrideAndRestrict={!isCoreChargerLogs}
        >
            <LoadManagementLink
                to={`${base}/core-charger-logs`}
                label="Core charger logs"
                nested={nested}
            />
        </AccessGuard>
        <AccessGuard
            unauthorizedBehaviour="hide"
            featureFlags={[FeatureFlag.COREV2_SITE_DIAGRAM_FLAG]}
        >
            <LoadManagementLink
                to={`${base}/site-diagram`}
                label="Site diagram"
                nested={nested}
            />
        </AccessGuard>
        <AccessGuard
            unauthorizedBehaviour="hide"
            featureFlags={[FeatureFlag.IL_4181_ASAT]}
            permissions={[
                IlluminateUserPermissionsEnum.SystemDeviceProvisioning,
                IlluminateUserPermissionsEnum.PartnerDeviceProvisioning,
            ]}
            permissionsSelector="any"
        >
            <LoadManagementLink
                to={`${base}/asat`}
                label="ASAT"
                nested={nested}
            />
        </AccessGuard>
    </>
);
